/**
 * Customer-facing labels for the bed configurator's footboard treatment step.
 * Keep the internal storage values unchanged: they are used by Threekit, SKU generation,
 * tile image filenames and saved configurations.
 */
export const FOOTBOARD_TREATMENT_LABELS = {
  "No Drawer": "High Leg Bed",
  "No Legs No Drawer": "Standard Bed",
  "End Drawer": "Storage Bed",
} as const;

/** Resolve a saved storage value to its display label, preserving unknown values. */
export const getFootboardTreatmentLabel = (storage: string): string =>
  FOOTBOARD_TREATMENT_LABELS[storage as keyof typeof FOOTBOARD_TREATMENT_LABELS] ?? storage;
